import { THREE } from 'expo-three';
import { injectable } from 'inversify';

@injectable()
export class ImageTextureCache {
  private _cache = new Map<string, THREE.Texture>();

  get = (
    url: string,
    onLoad?: (texture: THREE.Texture) => void
  ): THREE.Texture => {
    const _cached = this._cache.get(url);

    if (_cached) {
      // we return a clone because client may want to modify the texture
      const newTexture = _cached.clone();
      onLoad?.(newTexture);
      return newTexture;
    }

    const newTexture = new THREE.TextureLoader().load(url, onLoad);
    this._cache.set(url, newTexture);
    // we return a clone because client may want to modify the texture
    return newTexture.clone();
  };
}
